// IsoSofts central auth bridge.
// The real suite session lives in the `auth_token` cookie on the shared
// `.isosofts.com` domain (set by isosofts.com/los on login). ESD does not have
// its own login — it exchanges this token for an ESD session via /auth/sso.

export const ISOSOFTS_BASE_URL = 'https://isosofts.com';
export const ISOSOFTS_LOGIN_URL = `${ISOSOFTS_BASE_URL}/los`;

/** Read the shared IsoSofts JWT from the `auth_token` cookie (not HttpOnly). */
export function getIsosoftsToken(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)auth_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

/** No valid session anywhere → send the user to the central login. */
export function redirectToIsosoftsLogin(): void {
  window.location.href = ISOSOFTS_LOGIN_URL;
}

/** Leaving ESD → back to the IsoSofts suite home. */
export function redirectToIsosoftsHome(): void {
  window.location.href = ISOSOFTS_BASE_URL;
}

/** Full suite logout: clear the shared cookie (all subdomains) and go to login. */
export function logoutFromSuite(): void {
  document.cookie = 'auth_token=; domain=.isosofts.com; path=/; max-age=0; SameSite=Lax';
  window.location.href = ISOSOFTS_LOGIN_URL;
}
